import React from 'react';

import type { Control } from 'react-hook-form';

import TextFieldComp from '@/components/TextFieldComp';
import { ChestCircumference } from '@/domain/measure/service/entity/valueObjects/chestCircumference';
import { HeadCircumference } from '@/domain/measure/service/entity/valueObjects/headCircumference';
import { Height } from '@/domain/measure/service/entity/valueObjects/height';
import { Weight } from '@/domain/measure/service/entity/valueObjects/weight';

/**
 * 入力
 */
export type MeasureInputType = {
  /** 身長 */
  height: string,
  /** 体重 */
  weight: string,
  /** 頭囲 */
  headCircumference: string,
  /** 胸囲 */
  chestCircumference: string,
}

/**
 * プロパティ
 */
export type MeasureFormInputType = {
  /** コントロール */
  control: Control<MeasureInputType, never>,
  /** エラー */
  errors: any,
}

const MeasureFormInput: React.FC<MeasureFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <TextFieldComp
      type={Height.type}
      control={control}
      rules={Height.validationRule}
      name={Height.key}
      label={Height.label}
      placeholder={Height.placeholder}
      errors={errors}
    />
    <TextFieldComp
      type={Weight.type}
      control={control}
      rules={Weight.validationRule}
      name={Weight.key}
      label={Weight.label}
      placeholder={Weight.placeholder}
      errors={errors}
    />
    <TextFieldComp
      type={HeadCircumference.type}
      control={control}
      rules={HeadCircumference.validationRule}
      name={HeadCircumference.key}
      label={HeadCircumference.label}
      placeholder={HeadCircumference.placeholder}
      errors={errors}
    />
    <TextFieldComp
      type={ChestCircumference.type}
      control={control}
      rules={ChestCircumference.validationRule}
      name={ChestCircumference.key}
      label={ChestCircumference.label}
      placeholder={ChestCircumference.placeholder}
      errors={errors}
    />
  </div>
);

export default MeasureFormInput;
